import queryString from "query-string";
import {
  setStoreItemsCopy,
  updateStoreItemCopy,
  removeStoreItemCopy,
  addStoreCopy,
} from "./appifyActions";
import { privateFetchJson } from "apis";
import { removeEmptyParams, SecureLocalStorage } from "helpers";

// Cart Action Dispatchers
export const addToCart = (storeItem) => ({
  type: "ADD_TO_CART",
  storeItem,
});

export const updateItemInCart = (storeItem, index, oldItem) => ({
  type: "UDPATE_ITEM_IN_CART",
  storeItem,
  index,
  oldItem,
});

export const removeFromCart = (storeItem, index) => ({
  type: "REMOVE_FROM_CART",
  storeItem,
  index,
});

export const removeItemFromCart = (storeItem) => ({
  type: "REMOVE_ITEM_FROM_CART",
  storeItem,
});

export const removeCart = () => ({
  type: "REMOVE_CART",
});

export const updateProductQty = (cartItem, qty, index) => ({
  type: "UPDATE_PRODUCT_QTY",
  cartItem,
  qty,
  index,
});

export const setDeliveryMethod = (orderDeliveryType, deliveryCost) => ({
  type: "SET_DELIVERY_METHOD",
  orderDeliveryType,
  deliveryCost,
});

export const updateCustomerInfo = (orderCustomerInfo) => ({
  type: "UPDATE_CUSTOMER_INFO",
  orderCustomerInfo,
});

export const updateClientTotal = (clientTotal) => ({
  type: "UPDATE_CLIENT_TOTAL",
  clientTotal,
});

export const updateAdditionalComments = (comments) => ({
  type: "UPDATE_ADDITIONAL_COMMENTS",
  comments,
});

export const updateAddress = (id) => ({
  type: "UPDATE_ADDRESS",
  id,
});

export const updateAddressObject = (address) => ({
  type: "UPDATE_ADDRESS_OBJECT",
  address,
});

export const updatePaymentMethod = (method) => ({
  type: "UPDATE_PAYMENT_METHOD",
  method,
});

export const removePaymentMethod = () => ({
  type: "REMOVE_PAYMENT_METHOD",
});
